import { ErrorResponse, GlobalVariableValues, MessageParameters } from "@gtpl/shared-models/common-models";
import { AttendanceAdjustRequest, AttendanceMonthRequest, OverTimeResponse } from "@gtpl/shared-models/hrms";
import { CommonResponse, EmployeeCodeRequest } from "@gtpl/shared-models/masters";
import { AttendanceService } from "@gtpl/shared-services/hrms";
import { EmployeeService } from "@gtpl/shared-services/masters";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import { Injectable } from "@nestjs/common";
import moment from "moment";
import { getManager } from "typeorm";
import { OverTimeDTO } from "./dto/over-time-apply.dto";
import { OverTimeRequest } from "./dto/over-time-apply.request";
import { OTStatusRequest } from "./dto/over-time-status.request";
import { OverTimeAdapter } from "./dto/over-time.adapter";
import { OverTimeEntity } from "./over-time.entity";
import { OverTimeRepository } from "./over-time.repository";
import { WhatsappBroadCastService } from "@gtpl/shared-services/whatsapp-broad-cast";
import { WhatsAppLogDto } from "@gtpl/shared-models/whatsapp-broad-cast";

@Injectable()
export class OvertimeService {
    constructor(
        private overTimeRepo: OverTimeRepository,
        private overTimeAdapter: OverTimeAdapter,
        private attnService: AttendanceService,
        private wpService: WhatsAppNotificationService,
        private employeeService: EmployeeService,
        private wtsAppBroadCatService: WhatsappBroadCastService,
    ) { }

    async createOTApply(req: OverTimeRequest): Promise<any> {
        try {
            const savedDtos: OverTimeDTO[] = [];
            const date = moment(req.date).format('YYYY-MM-DD');
            const month = moment(req.date).month() + 1;
            const employeeCodes = [];
            for (const otDetail of req.otDetails) {
                const empOTData = await this.overTimeRepo.getOtDetails(otDetail.employeeCode, date);
                if (empOTData.length > 0) {
                    employeeCodes.push(empOTData[0].employeeCode);
                    continue;
                } else {
                    const request = new AttendanceAdjustRequest(otDetail.employeeCode, date);
                    const empInfo = await this.attnService.getPresentEmployeeDataByEmpCode(request);
                    const dto = new OverTimeDTO();
                    dto.employeeCode = otDetail.employeeCode;
                    dto.date = date;
                    dto.otType = otDetail.otType;
                    dto.otHours = otDetail.otHours;
                    dto.employeeName = empInfo.data[0].employeeName;
                    dto.inTime = empInfo.data[0].inTime;
                    dto.outTime = empInfo.data[0].outTime;
                    dto.month = month;
                    dto.createdUser = req.createdUser;
                    const convertedEntity: OverTimeEntity = this.overTimeAdapter.converDtoToEntity(dto);
                    const savedEntity: OverTimeEntity = await this.overTimeRepo.save(convertedEntity);
                    const savedDto: OverTimeDTO = this.overTimeAdapter.convertEntityToDto(savedEntity);
                    savedDtos.push(savedDto);
                }
            }
            // for (const dto of savedDtos) {
            // await this.otApplyRequestMessage(dto);
            // }
            // if (employeeCodes.length > 0) {
            //     return new OverTimeResponse(true, 1, 'Over Time Applied successfully')
            // }
            return new OverTimeResponse(true, 1, 'Over Time Applied Successfully', savedDtos);
        } catch (error) {
            throw error;
        }
    }

    async getOverTimeTableData(): Promise<CommonResponse> {
        const datas = await this.overTimeRepo.find({ order: { date: 'DESC' } });
        const response = [];
        for (const data of datas) {
            const tableData = this.overTimeAdapter.convertEntityToDto(data);
            response.push(tableData);
        }
        if (response) {
            return new CommonResponse(true, 11107, 'Data retrieved successfully', response);
        } else {
            throw new ErrorResponse(11106, ' Data not Found ');
        }
    }

    async getOTHoursByEmployeeCode(req: AttendanceMonthRequest): Promise<CommonResponse> {
        const data = await this.overTimeRepo.getOtHours(req.month);
        if (data) {
            return new CommonResponse(true, 11107, 'Details retrived successfully', data);
        } else {
            return new CommonResponse(false, 11108, 'Data not Found')
        }
    }

    async getOTShiftsByEmployeeCode(req: AttendanceMonthRequest): Promise<CommonResponse> {
        const data = await this.overTimeRepo.getOtShifts(req.month);
        if (data) {
            return new CommonResponse(true, 11107, 'Details retrived successfully', data);
        } else {
            return new CommonResponse(false, 11108, 'Data not Found')
        }
    }

    async getOTDetailsById(req: OTStatusRequest): Promise<CommonResponse> {
        const entity = await this.overTimeRepo.findOne({ otId: req.otId, employeeCode: req.employeeCode });
        if (entity) {
            const response: OverTimeDTO = this.overTimeAdapter.convertEntityToDto(entity);
            if (response) {
                return new CommonResponse(true, 11107, 'Details retrived successfully', response);
            } else {
                return new CommonResponse(false, 11106, ' Error in converting to DTO ');
            }
        } else {
            return new CommonResponse(false, 11108, 'Data not Found')
        }
    }

    async updateOTStatus(req: OTStatusRequest): Promise<CommonResponse> {
        const response = await this.overTimeRepo.update({ otId: req.otId, employeeCode: req.employeeCode }, { status: req.status, updatedUser: req.updatedUser });
        if (response) {
            // await this.otApplyResponseMessage(req);
            return new CommonResponse(true, 11107, 'Status updated successfully');
        } else {
            throw new ErrorResponse(11106, ' Error in update of OT Status ');
        }
    }

    async otApplyRequestMessage(req: OverTimeDTO): Promise<CommonResponse> {
        try {
            const empReq = new EmployeeCodeRequest(req.employeeCode);
            const empData = await this.employeeService.getEmployeeByEmpCode(empReq);
            const contractors = {
                "DEVUDU": "9885435743",
                "SHAJU": "7207087521",
                "RS": "8114313829",
                "JAYA SRI": "9121765646",
                "MSN": "6301173733",
                "NARAYANA": "7993854249"
            }

            function getMobileNumber(contractorName: string) {
                const number = contractors[contractorName];
                if (number) {
                    return number;
                }
            }

            const parameters = [
                { "type": "text", "text": req.employeeName },
                { "type": "text", "text": req.employeeCode },
                { "type": "text", "text": req.date },
                { "type": "text", "text": req.otHours },
                { "type": "text", "text": 'Applied' },
                { "type": "text", "text": 'Sandhya Aqua' }
            ]

            let contacts = [];
            const cNo = getMobileNumber(empData.data.contractorName);
            contacts.push(cNo);
            if (empData.data.mobileNumber)
                contacts.push(empData.data.mobileNumber);
            let statusFlag = true;
            for (const contact of contacts) {
                const req = new MessageParameters('91' + contact, 'over_time_response', parameters, "en_us")
                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                console.log(messageStatus)
                if (!messageStatus.status) {
                    statusFlag = false;
                } else {
                    statusFlag = true;
                    const whatsapplogDto = new WhatsAppLogDto(contact, 'over_time_response', 'Sandhya', GlobalVariableValues.companyId, GlobalVariableValues.hrmsModuleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }
            }
            if (statusFlag) {
                return new CommonResponse(true, 11108, "Message Sent Sucessfully")
            } else {
                return new CommonResponse(false, 11109, 'Message sending failed')
            }
        } catch (error) {
            console.log(error, 'error--')
            throw error;
        }
    }

    async otApplyResponseMessage(req: OTStatusRequest): Promise<CommonResponse> {
        try {
            const empReq = new EmployeeCodeRequest(req.employeeCode);
            const empData = await this.employeeService.getActiveEmployeesByEmpCode(empReq);
            const otData = await this.getOTDetailsById(req);
            const data = otData.data;
            const contractors = {
                "DEVUDU": "9966732170",
                "SHAJU": "7207087521",
                "RS": "8114313829",
                "JAYA SRI": "9121765646",
                "MSN": "6301173733",
                "NARAYANA": "7993854249"
            }

            function getMobileNumber(contractorName: string) {
                const number = contractors[contractorName];
                if (number) {
                    return number;
                }
            }

            const parameters = [
                { "type": "text", "text": data.employeeName },
                { "type": "text", "text": data.employeeCode },
                { "type": "text", "text": data.date },
                { "type": "text", "text": data.otHours },
                { "type": "text", "text": data.status },
                { "type": "text", "text": 'Sandhya Aqua' }

            ]
            let contacts = [];
            const cNo = getMobileNumber(empData.data.contractorName);
            contacts.push(cNo);
            if (empData.data.mobileNumber)
                contacts.push(empData.data.mobileNumber);
            let statusFlag = true
            for (const contact of contacts) {
                const req = new MessageParameters('91' + contact, 'over_time_response', parameters, "en_us")
                console.log(req, 'RRRRRRR');
                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                console.log(messageStatus)
                if (!messageStatus.status) {
                    statusFlag = false;
                } else {
                    statusFlag = true;
                    const companyId = 7;
                    const hrmsModuleId = 2;
                    const whatsapplogDto = new WhatsAppLogDto(contact, 'over_time_response', 'Sandhya', companyId, hrmsModuleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }
            }
            if (statusFlag) {
                return new CommonResponse(true, 11108, "Message Sent Sucessfully")
            } else {
                return new CommonResponse(false, 11110, "Message Sending Failed")
            }
        } catch (error) {
            console.log(error, 'error--')
            throw error;
        }
    }

}
